import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormSalarySelectionDrawerManagerContent from './Content'
import CustomFormSalarySelectionDrawerManagerProvider from './contexts/CustomFormSalarySelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormSalarySelectionDrawer: FC<Props> = ({ question, questionKey, disabled }) => {
  return (
    <CustomFormSalarySelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormSalarySelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormSalarySelectionDrawerManagerProvider>
  )
}

export default CustomFormSalarySelectionDrawer
